export default "__VITE_ASSET__CEDXR50h__"